import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const nonePosApi = factory.get("nonePos");
const initialState = {
  searchBody: {
    name: "",
    mobile: "",
    province_id: null,
    city_id: null,
    is_register: null,
    status_id: null,
    activity_id: null,
  },
  nonePos: {
    loading: false,
    dialog: false,
    form: {
      id: null,
      name: "",
      mobile: "",
      note: "",
      province_id: null,
      city_id: null,
      is_register: false,
      status_id: 1,
      activity_id: 1,
      longitude: "",
      latitude: "",
      nearest_point: "",
      pin_type_id: 1,
    },
  },
  nonePoses: {
    loading: false,
    data: [],
    total: 0,
  },
  subCategoriesList: {
    loading: false,
    data: [],
    total: 0,
  },
  lastOtp: {
    dialog: false,
    data: [],
  },
  mapData: {
    data: [],
    dialog: false,
    loading: false,
  },
  isRegister: [
    { label: "مسجلة قي النظام", value: 1 },
    { label: "غير مسجلة في النظام", value: 0 },
  ],
  statuses: [
    { label: "فعال", value: 1 },
    { label: "غير فعال", value: 2 },
  ],
  activities: [
    { label: "يتعامل", value: 1 },
    { label: "لا يتعامل", value: 2 },
    { label: "مشترك", value: 3 },
  ],
  pinTypes: [
    { label: "ورقي", value: 1 },
    { label: "بلاستك", value: 2 },
    { label: "بلاستك وورقي", value: 3 },
    { label: "لا يتعامل بالكارتات", value: 4 },
  ],
};

export const nonePosSlice = createSlice({
  name: "nonePos",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.nonePos.dialog = !state.nonePos.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.nonePoses.data = payload.data.data;
      state.nonePoses.total = payload.data.total;
    },
    setDataList: (state, { payload }) => {
      state.subCategoriesList.data = payload.data.data;
    },
    setById: (state, { payload }) => {
      state.nonePos.form = payload;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.nonePos.form = initialState.nonePos.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
    setMapDataDialog: (state, { payload }) => {
      state.mapData.dialog = !state.mapData.dialog;
      if (payload) {
        state.mapData.data = payload;
      } else {
        state.mapData.data = [];
      }
    },
    // New explicit controls for map dialog and loading
    openMapDialog: (state) => {
      state.mapData.dialog = true;
    },
    closeMapDialog: (state) => {
      state.mapData.dialog = false;
    },
    setMapData: (state, { payload }) => {
      state.mapData.data = payload || [];
    },
    setMapLoading: (state, { payload }) => {
      state.mapData.loading = Boolean(payload);
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setDataList,
  setMapDataDialog,
  openMapDialog,
  closeMapDialog,
  setMapData,
  setMapLoading,
} = nonePosSlice.actions;

export default nonePosSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("nonePos"));
    const res = await nonePosApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("nonePos"));
  } catch (err) {
    dispatch(setLoading("nonePos"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await nonePosApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("nonePos"));
    const res = await nonePosApi.getById(id);
    dispatch(setById(res.data.data[0]));

    dispatch(setDialog());
    dispatch(setLoading("nonePos"));
  } catch (err) {
    dispatch(setLoading("nonePos"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    await nonePosApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await nonePosApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

// Fetch all locations for map (same filters as list, without pagination)
const getLocations = (params) => async (dispatch) => {
  try {
    // open dialog with loading indicator
    dispatch(openMapDialog());
    dispatch(setMapLoading(true));
    dispatch(setMapData([]));

    const res = await nonePosApi.getLocations(params);
    dispatch(setMapData(res?.data?.data ?? []));
    dispatch(setMapLoading(false));
  } catch (err) {
    dispatch(setMapLoading(false));
    dispatch(closeMapDialog());
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] || "حدث خطأ غير متوقع",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const NonePos = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  getLocations,
};
